<template>
    <div id="import_data_review_list">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Import Data Review List</div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content import-datareview-list">
                        <data-table-filter-config :moduleName="'importDataList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'importDataList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listImportDataReviewTable"
                                    mode="remote"
                                    title="ImportDataReview"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                    enabled: false,
                                    position: 'both',
                                    perPage: perPage,
                                    perPageDropdown:dropDownPerPage,
                                    dropdownAllowAll: false,
                                    }">
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateImport">
                                                    <router-link title="Fix Record" class="fp-edit" v-bind:to="{name: props.row.module_reference+'Create',params:{import_data_error_id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";


import EventBus from "././event-bus";


import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "ImportDataReviewList",
        metaInfo() {
            return {
                title: "Import Data Review List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                    hidden:false,
                },
                {
                    label: 'SR No',
                    field: 'id',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "SR No", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Module Name',
                    field: 'module_name',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Module Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Imported By',
                    field: 'imported_by',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Imported By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Import Time',
                    field: 'import_time',
                    fpFieldType:"date",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Import Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Duplicate',
                    field: 'duplicate',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Duplicate", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Yes','No'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Error Reason',
                    field: 'error_reason',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Error Reason", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            canUpdateImport:false
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_import_data_review') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_import_data_review') {
                            self.canUpdateImport = true;
                        }

                    }
                }

            }
        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listImportDataReviewTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    // messageData: self.message,
                    sort: self.serverParams.sort,
                    // exportFiltered: self.exportFilteredFlag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/importdatareview/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'load-import-data-review-list')
                    }
                });
            },
            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ImportDataReviewList.vue